import Markdown from "react-markdown";

import {
  FirstLineStyled,
  SecondLineStyled,
  SubheaderContainerStyled,
} from "./Subheader.styled";

export interface SubheaderContent {
  firstLine: string;
  secondLine: string;
}

interface SubheaderProps {
  className?: string;
  content: SubheaderContent;
}

export const Subheader = ({ className, content }: SubheaderProps) => {
  return (
    <SubheaderContainerStyled maxWidth="desktopXl" className={className}>
      <FirstLineStyled>{content.firstLine}</FirstLineStyled>
      <SecondLineStyled>
        <Markdown>{content.secondLine}</Markdown>
      </SecondLineStyled>
    </SubheaderContainerStyled>
  );
};
